import { render } from "./RegisterQuestion.vue?vue&type=template&id=64d8c36e&scoped=true"
import script from "./RegisterQuestion.vue?vue&type=script&lang=js"
export * from "./RegisterQuestion.vue?vue&type=script&lang=js"

import "./RegisterQuestion.vue?vue&type=style&index=0&id=64d8c36e&scoped=true&lang=scss"

import exportComponent from "/opt/render/project/src/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-64d8c36e"]])

export default __exports__